<template>
  <button class="filters-header" @click="$emit('click')">
    <span class="filters-header__content">
      Filtruj lokalizacje <span v-if="count">({{ count }})</span>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .filters-header {
    @include reset-button;
    margin-top: 60px;

    width: 100%;
    text-align: center;

    padding: 32px 0;

    border-bottom: 1px solid #ccc;

    &__content {
      @include uppercase-text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Settings/FiltersHeader.vue